// Module
var code = "<ul class=\"list-unstyled row ups-cv_card_container\">\r\n    <ng-content select=\"ups-card-content\"></ng-content>\r\n</ul>\r\n";
// Exports
module.exports = code;